import React, { useState } from 'react';
import cn from 'classnames';

import { useGetListPaymentsQuery } from '../../redux/paymentsApi';
import Layout from '../../components/layout/Layout';
import PaymentItem from '../../components/common/features/PaymentItem';
import DeviceSidebar from '../../components/common/features/DeviceSidebar';
import useWindowSize from '../../hooks/useWindowSize';
import useGetCharges from '../../hooks/useGetCharges';
import useGetSubscriptions from '../../hooks/useGetSubscriptions';
import Loader from '../../components/common/ui/Loader';
import ChargesList from './ChargesList';

import styles from './styles.module.scss';
import { useGetCustomerQuery } from '../../redux/customersApi';

const Billing = () => {
  const windowSize = useWindowSize();
  const isResponsive = windowSize?.width < 1300;
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [subscriptions, subscriptionsLoading] = useGetSubscriptions();
  const [upcomingCursor, setUpcomingCursor] = useState(null);
  const [prevChargeCursor, setPrevChargeCursor] = useState(null);
  const { data: customer } = useGetCustomerQuery();
  const [
    upcomingCharges,
    upcomingChargesLoading,
    { nextCursor: upcomingNextCursor, prevCursor: upcomingPrevCursor },
  ] = useGetCharges(
    upcomingCursor
      ? {
          limit: 20,
          cursor: upcomingCursor,
        }
      : {
          status: 'queued',
          limit: 20,
          include: 'payment_methods',
          purchase_item_id: selectedSubscription || 0,
        },
  );
  const [
    previousCharges,
    previousChargesLoading,
    { nextCursor: previousNextCursor, prevCursor: previousPrevCursor },
  ] = useGetCharges(
    {
      customer_id: customer?.id,
      limit: 20,
      purchase_item_id: selectedSubscription || null,
      cursor: prevChargeCursor,
    },
    true,
  );
  const { data: paymentsData, loading: paymentLoading } =
    useGetListPaymentsQuery();
  const handleDeviceClick = (subId) => {
    setUpcomingCursor(null);
    setPrevChargeCursor(null);
    setSelectedSubscription(subId);
  };

  return (
    <Layout className={styles.billing}>
      <div className={styles.billingMain}>
        <h1 className={cn('h2', styles.billingTitle)}>Billing & Cards</h1>
        <ul className={styles.billingPayments}>
          {paymentLoading ? (
            <div className={styles.billingPaymentMethodsLoader}>
              <Loader show={paymentLoading} />
            </div>
          ) : (
            <>
              {paymentsData?.payment_methods?.map((paymentMethod) => (
                <PaymentItem
                  key={paymentMethod.id}
                  paymentDetails={paymentMethod}
                ></PaymentItem>
              ))}
            </>
          )}
        </ul>
        {isResponsive && (
          <DeviceSidebar
            isLoading={subscriptionsLoading}
            showAllDeviceBtn
            subscriptions={subscriptions}
            selectedSubscription={selectedSubscription}
            setSelectedSubscription={handleDeviceClick}
          />
        )}
        <div className={styles.billingLists}>
          <div className={styles.billingList}>
            <h2 className={styles.billingListTitle}>
              Upcoming Charge{Boolean(upcomingCharges.length) && '*'}
            </h2>
            <ChargesList
              type="upcoming"
              charges={upcomingCharges}
              changeCursor={setUpcomingCursor}
              prevCursor={upcomingPrevCursor}
              nextCursor={upcomingNextCursor}
              loading={upcomingChargesLoading}
            />
          </div>
          <div className={styles.billingList}>
            <h2 className={cn(styles.billingListTitle)}>Previous</h2>
            <ChargesList
              type="previous"
              charges={previousCharges}
              changeCursor={setPrevChargeCursor}
              prevCursor={previousPrevCursor}
              nextCursor={previousNextCursor}
              loading={previousChargesLoading}
            />
          </div>
        </div>
      </div>
      {!isResponsive && (
        <DeviceSidebar
          notAllowSelectNotAvailableSubs={false}
          isLoading={subscriptionsLoading}
          showAllDeviceBtn
          subscriptions={subscriptions}
          selectedSubscription={selectedSubscription}
          setSelectedSubscription={handleDeviceClick}
        />
      )}
    </Layout>
  );
};

export default Billing;
